module.exports = __webpack_public_path__ + "img/01.f0b96cc1.png";